<template>
    <div><!--ini -->
    <h1>Seleccion de Indicadores</h1>
   
  <div> <v-breadcrumbs :items="items" large></v-breadcrumbs> </div>
    
  <v-card class="blue-grey lighten-5 ma-3 pa-3">
<v-row>
  <v-col cols="6">
    
      <template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    hide-default-footer
    item-key="name"
    show-select
    class="elevation-1"
  ></v-data-table>
</template>

  </v-col>
   <v-col cols="6">

     <template>
  <v-data-table
    :headers="headers2"
    :items="desserts2"
    hide-default-footer
    item-key="name"
    show-select
    class="elevation-1"
  ></v-data-table>
</template>

  </v-col>
</v-row>
</v-card>

    </div>
</template>

<script>
    export default {
  name: 'seleccionIndicadores',

  data() {
    return {

        nombre: '',
    
        items: [
        {
          text: 'Inicial',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Matematica',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Matematica ini',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: '5 años',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],

       singleSelect: true,

        selected: [],
        headers: [
          {
            text: 'Mostrar Competencias',
            align: 'left',
            sortable: false,
            value: 'name',
          },
       //   { text: 'Seleccionadas', value: 'calories' },
         
          
        ],
        desserts: [
          {
            name: 'CONSTRUYE SU IDENTIDAD',
         //   calories: 159,
          },
         
        ],

       

        selected2: [],
        headers2: [
          {
            text: 'Capasidades',
            align: 'left',
            sortable: false,
            value: 'name',
            class: 'info'
          },
       //   { text: 'Seleccionadas', value: 'calories' },
         
          
        ],
        desserts2: [
          {
            name: 'Interactúa con todas las personas',
         //   calories: 159,
          },
          {
            name: 'Construye y asume acuerdos y normas',
          //  calories: 305,
          },
          {
            name: 'Maneja conflictos de manera constructiva',
           // calories: 356,
          },
          {
            name: 'Delibera sobre asuntos públicos',
          //  calories: 375,
          },
          {
            name: 'Participa en acciones que promueven el bienestar común',
         //   calories: 392,
          },
        
     
        ],



        //
        

    };

  },
 
  mounted() {
     
    },

  methods: {

    },

  components: {

  }
}
</script>

<style scoped>
@font-face {
    font-family: "avenir black";
    src: url("../../public/fuentes/Avenir-Black.ttf");
    }

    @font-face {
    font-family: "avenir black oblique";
    src: url("../../public/fuentes/Avenir-BlackOblique.ttf");
    }

    .btn_block_style2{
        font-family: "avenir black";
        letter-spacing: 0.42px;
        font-size: 14px;
        background-color: #0277bd !important;
    }

    .btn_block_style2:hover {
        font-family: "avenir black oblique";
        /* background-color: #002f6c !important; */
        background-color: #ffbc00 !important;
        color: #000;
    }

</style>